import { createAction } from '@reduxjs/toolkit';
import { IDiscountProgrammInfo, IDiscountWarning, IProductDiscountInfo } from '../models/order-discount-info.model';

export const DISCOUNTS_UPDATE = '[Discounts] DISCOUNTS_UPDATE';
export const DISCOUNTS_CLEAR = '[Discounts] DISCOUNTS_CLEAR';
export const DISCOUNTS_SHOULD_BE_UPDATED = '[Discounts] DISCOUNTS_SHOULD_BE_UPDATED';


export const discountsUpdateAction = createAction<{
  productDiscounts: IProductDiscountInfo[];
  programs: IDiscountProgrammInfo[];
  totalDiscount: number;
  freeProductExternalIds: string[];
  warnings: IDiscountWarning[];
}>(DISCOUNTS_UPDATE);
export const discountsClearAction = createAction<void>(DISCOUNTS_CLEAR);
export const discountsShouldBeUpdatedAction = createAction<void>(DISCOUNTS_SHOULD_BE_UPDATED);
